export const TIME_VALUES = {
  4: 0,
  225: 10, // change to 154 in pre
  219: 5,
  218: 15,
};
